import { all, equals } from 'ramda';

export default (...props: boolean[]) => all(equals(true))(props);
